// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Textarea psicologia */
.textarea-full {
  flex: 1 1 100%;
  /* Ocupar toda a largura disponível */
}

.textarea-full textarea {
  width: 100%;
  resize: none;
  /* Impedir o redimensionamento */
}


/* Flags da admisaão ou consulta */
.flag-admissao {
  color: #0a7c0a;
  font-weight: bold;
}

.flag-consulta {
  color: #004aad;
  font-weight: bold;
}

.flag-consulta-button {
  background: none;
  border: none;
  color: #007bff;
  font-weight: bold;
}

/* Layout genérico para páginas estáticas de saúde */
.health-shell {
  display: flex;
  min-height: 100vh;
  background: #f6f8ff;
}

.health-shell-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background: #f6f8ff;
}

.health-shell-body {
  padding: 16px 20px 28px;
  background: #f6f8ff;
}

.health-search-card {
  background: #fff;
  border: 1px solid #e7ebf5;
  border-radius: 14px;
  padding: 12px 14px;
  box-shadow: 0 6px 18px rgba(17, 24, 39, 0.06);
  margin-bottom: 16px;
}

.health-static-section {
  background: #f6f8ff;
  border-radius: 16px;
  padding: 12px;
}

.health-static-layout {
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 18px;
  align-items: start;
  margin-top: 8px;
}

.health-static-avatar {
  background: #fff;
  border: 1px solid #e7ebf5;
  border-radius: 16px;
  padding: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 240px;
  box-shadow: 0 8px 20px rgba(17, 24, 39, 0.05);
}

.health-static-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
}

.health-static-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 12px;
}

.health-static-field {
  background: #fff;
  border: 1px solid #e7ebf5;
  border-radius: 12px;
  padding: 12px 14px;
  min-height: 64px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0 4px 14px rgba(17, 24, 39, 0.04);
}

.health-static-field span {
  font-size: 13px;
  font-weight: 700;
  color: #3a4a70;
  margin-bottom: 6px;
}

.health-static-field p {
  font-size: 14px;
  color: #4b5563;
  margin: 0;
}

@media (max-width: 900px) {
  .health-static-layout {
    grid-template-columns: 1fr;
  }

  .health-static-avatar {
    height: 200px;
  }
}

/* Formulário de Admissão */
.health-card {
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-lg);
  padding: 16px;
  margin-top: 16px;
  box-shadow: var(--ui-shadow-sm);
}

.health-grid-two {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 12px;
  margin-top: 10px;
}

.health-options-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 16px;
  align-items: center;
  margin-top: 8px;
}

.toggle-field {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #f3f6ff;
  border: 1px solid #e1e7f5;
  padding: 8px 12px;
  border-radius: 999px;
}

.toggle-label {
  font-size: 13px;
  font-weight: 600;
  color: #6b7a90;
  min-width: 32px;
  text-align: center;
}

.toggle-label.active {
  color: #1c3faa;
}

.toggle-switch {
  position: relative;
  width: 44px;
  height: 24px;
  display: inline-block;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #cfd8ee;
  transition: 0.2s ease;
  border-radius: 999px;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  top: 3px;
  background-color: #fff;
  transition: 0.2s ease;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.toggle-switch input:checked+.toggle-slider {
  background-color: #1c6ef2;
}

.toggle-switch input:checked+.toggle-slider:before {
  transform: translateX(20px);
}

.health-option {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: var(--ui-text);
}

.health-option-set {
  background: var(--ui-input-bg);
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-md);
  padding: 10px;
}

.health-subtitle {
  font-size: 14px;
  font-weight: 700;
  color: var(--ui-text);
  margin: 0 0 6px 0;
}

.health-inline-input {
  width: 100%;
  min-width: 180px;
  padding: 10px 12px;
  border: 1px solid #d7dce8;
  border-radius: 10px;
  outline: none;
  font-size: 14px;
  background-color: #fff !important;
}

.health-inline-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
  margin-top: 12px;
}

.health-table {
  margin-top: 12px;
  border: 1px solid #e7ebf5;
  border-radius: 12px;
  overflow: hidden;
  width: 100%;
  background: #fff;
  box-shadow: 0 6px 16px rgba(17, 24, 39, 0.04);
}

.health-table-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-bottom: 1px solid #eef1f7;
  background: #fff;
  align-items: center;
}

.health-table-row:last-child {
  border-bottom: none;
}

.health-table-row div {
  padding: 10px 12px;
  font-size: 14px;
  color: #2e3b5f;
}

.health-table-row.header {
  background: #f6f8ff;
  font-weight: 600;
  color: #1f2a44;
  position: static;
  text-transform: uppercase;
  letter-spacing: 0.2px;
  font-size: 12px;
  padding: 10px;
}

.health-table-row.active {
  background: #eef2ff;
}

.health-table.three-cols .health-table-row {
  grid-template-columns: 1fr 1fr 1fr;
}

.health-table.five-cols .health-table-row {
  grid-template-columns: 1.1fr 0.7fr 0.7fr 0.7fr 1.3fr;
}

.health-table-row input[type="checkbox"] {
  width: 16px;
  height: 16px;
  display: block;
  margin: 0 auto;
}

.health-table-row input[type="text"] {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #dce1ee;
  border-radius: 10px;
  background: #f7f8ff;
}

.health-table-row.header {
  position: static;
}

.health-inline-input.highlight {
  background: #eef2ff;
  border-color: #d4dbf7;
}

.demand-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.demand-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 12px;
  align-items: flex-start;
}

.demand-col {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.demand-col textarea,
.demand-col input[type="text"],
.demand-col input[type="date"],
.demand-col input[type="time"] {
  width: 100%;
}

.demand-col.flex-1 {
  flex: 1 1 100%;
}

.demand-col.flex-2 {
  flex: 1 1 48%;
}

.demand-col.flex-3 {
  flex: 1 1 60%;
}

.demand-row.vitals {
  gap: 8px 10px;
  margin-top: 0;
}

.tb-section-block {
  width: 100%;
  border: 1px solid #e7ebf5;
  border-radius: 12px;
  padding: 12px;
  background: #fff;
  margin-top: 10px;
}

.tb-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 14px;
  align-items: flex-start;
}

.tb-col {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1 1 220px;
}

.tb-col.flex-1 {
  flex: 1 1 100%;
}

.tb-col input,
.tb-col select,
.tb-col textarea {
  width: 100%;
}

.ficha-pdf {
  margin-top: 20px;
}

.question-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 12px;
  width: 100%;
  justify-content: stretch;
  align-items: stretch;
}

.question-card {
  background: #f7f9fe;
  border: 1px solid #e7ebf5;
  border-radius: 12px;
  padding: 12px 14px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
}

.question-title {
  margin: 0 0 8px 0;
  font-weight: 600;
  color: #2c3a4b;
  font-size: 14px;
}

@media (max-width: 768px) {
  .demand-row {
    flex-direction: column;
  }
}

@media (max-width: 640px) {
  .health-inline-input {
    min-width: 0;
  }

  .health-options-row {
    gap: 8px;
  }
}

.health-inline-action {
  border: none;
  background: transparent;
  color: #2a5dc7;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  margin-top: 6px;
}

.health-inline-action:hover {
  text-decoration: underline;
}

.timeline-inline {
  display: flex;
  align-items: center;
  gap: 12px;
}

.health-inline-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 8px;
}

.health-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.health-list__row {
  align-items: end;
}

.health-inline-add {
  border: 1px dashed #9bb4e6;
  background: #f3f6ff;
  color: #2a5dc7;
  font-weight: 600;
  border-radius: 10px;
  padding: 8px 12px;
  cursor: pointer;
}

.health-inline-add:hover {
  background: #eef2ff;
}

.health-inline-remove {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  border: 1px solid #f2b8b5;
  background: #fff;
  color: #cc3b3b;
  font-weight: 700;
  cursor: pointer;
}

.health-note {
  margin: 6px 0 14px;
  font-size: 0.9rem;
  color: #6c7a94;
}

.health-input-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.health-input-actions .health-inline-input {
  flex: 1 1;
}

.health-action-btn {
  border: 1px solid #cfd8ee;
  background: #f7f9ff;
  color: #41527a;
  border-radius: 6px;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
}

.health-action-btn.danger {
  border-color: #efc5c5;
  color: #c43c3c;
  background: #fff6f6;
  padding: 0;
}

.health-action-btn:hover {
  background: #edf2ff;
}

.health-action-btn.danger:hover {
  background: #ffeaea;
}

.health-row-below {
  display: flex;
  justify-content: flex-end;
  padding: 10px 20px 10px 0px;
}

.health-row-file {
  display: flex;
  justify-content: flex-start;
  padding: 6px 0 4px;
}

.health-row-file input[type="file"] {
  width: 100%;
  max-width: 320px;
}

/* === Admissão (novo layout) === */
.admission-page {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.admission-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  padding: 4px 4px 0;
}

.admission-title h2 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e2a45;
}

.admission-title p {
  margin: 6px 0 0;
  color: #6b7a99;
  font-size: 0.95rem;
}

.admission-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.admission-chip {
  background: #eef2ff;
  color: #2c3e6b;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 0.85rem;
  font-weight: 600;
  border: 1px solid #dfe6fb;
}

.admission-hero {
  display: grid;
  grid-template-columns: 150px 1fr;
  gap: 20px;
  padding: 18px;
  border-radius: 18px;
  background: linear-gradient(135deg, #f8faff 0%, #ffffff 100%);
  border: 1px solid #e4e9f6;
  box-shadow: 0 8px 24px rgba(17, 24, 39, 0.06);
}

.admission-hero-avatar img {
  width: 150px;
  height: 150px;
  border-radius: 16px;
  object-fit: cover;
  border: 1px solid #e0e6f5;
}

.admission-hero-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.admission-hero-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 12px 18px;
}

.admission-hero-row--3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.admission-hero-row--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.admission-info-item {
  background: #f7f9ff;
  border: 1px solid #e2e8fb;
  border-radius: 12px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.admission-info-item span {
  font-size: 0.78rem;
  color: #7a88a8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.admission-info-item strong {
  font-size: 0.95rem;
  color: #1f2a44;
  font-weight: 600;
}

.admission-card {
  background: #ffffff;
  border: 1px solid #e4e9f6;
  border-radius: 18px;
  padding: 18px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
}

.admission-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.admission-card__header h3 {
  margin: 0;
  font-size: 1.1rem;
  color: #1e2a45;
}

.admission-card__hint {
  font-size: 0.82rem;
  color: #7b88a6;
}

.admission-grid {
  display: grid;
  gap: 14px;
}

.admission-grid,
.admission-grid {
  margin-top: 14px;
}

.admission-grid--2 {
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
}

.admission-grid--3 {
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
}

.admission-input {
  background: #f6f8ff;
}

.admission-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 4px;
  gap: 6px;
}

.admission-timeline {
  margin-top: 6px;
  background: #ffffff;
  border: 1px solid #e4e9f6;
  border-radius: 18px;
  padding: 18px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
}

.timeline-vitals {
  padding: 10px;
  background-color: #f7f9ff;
}

.timeline-vitals-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 6px 12px;
  font-size: 0.92rem;
}

@media (max-width: 1480px) {
  .admission-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .admission-title {
    width: 100%;
  }

  .admission-chips {
    width: 100%;
    justify-content: flex-start;
    gap: 8px;
  }

  .admission-chip {
    font-size: 0.8rem;
    padding: 5px 10px;
  }
}

@media (max-width: 960px) {
  .admission-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .admission-hero {
    grid-template-columns: 1fr;
  }

  .admission-hero-avatar img {
    width: 96px;
    height: 96px;
  }

  .admission-hero-row--3,
  .admission-hero-row--2 {
    grid-template-columns: 1fr;
  }
}

/* Fluxo de tuberculose em abas */
.tb-tabs-layout {
  padding: 18px;
}

.tb-tabs-header {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 14px;
}

.tb-tab-btn {
  border: 1px solid #d5def2;
  background: #f7f9ff;
  color: #2d3e66;
  padding: 8px 12px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.tb-tab-btn.active {
  background: #2d57cf;
  border-color: #2d57cf;
  color: #fff;
}

.tb-tab-btn.disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.tb-step-card {
  border: 1px solid #e4e9f6;
  border-radius: 14px;
  padding: 14px;
  background: #fbfcff;
}

.tb-step-card h4 {
  margin: 0 0 12px;
  color: #1f2a44;
  font-size: 1.05rem;
}

.tb-step-card input:not([type="checkbox"]):not([type="radio"]):not([type="file"]),
.tb-step-card select,
.tb-step-card textarea,
.tb-transfer-box input:not([type="checkbox"]):not([type="radio"]):not([type="file"]),
.tb-transfer-box select,
.tb-transfer-box textarea,
.tb-sinan-box input:not([type="checkbox"]):not([type="radio"]):not([type="file"]),
.tb-sinan-box select,
.tb-sinan-box textarea {
  background: #fff;
  border: 1px solid #d7dce8;
  border-radius: 10px;
}

.tb-step-card input:not([type="checkbox"]):not([type="radio"]):not([type="file"]):focus,
.tb-step-card select:focus,
.tb-step-card textarea:focus,
.tb-transfer-box input:not([type="checkbox"]):not([type="radio"]):not([type="file"]):focus,
.tb-transfer-box select:focus,
.tb-transfer-box textarea:focus,
.tb-sinan-box input:not([type="checkbox"]):not([type="radio"]):not([type="file"]):focus,
.tb-sinan-box select:focus,
.tb-sinan-box textarea:focus {
  outline: none;
  border-color: #8fb0f5;
  box-shadow: 0 0 0 3px rgba(45, 87, 207, 0.08);
}

.tb-triage-list {
  display: grid;
  gap: 10px;
}

.tb-triage-item {
  border: 1px solid #e2e8fb;
  border-radius: 12px;
  background: #f7f9ff;
  padding: 10px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.tb-triage-item p {
  margin: 0;
  font-size: 14px;
  color: #2a3550;
}

.tb-yes-no {
  display: flex;
  gap: 8px;
}

.tb-yes-no button {
  min-width: 56px;
  border: 1px solid #d2dbef;
  border-radius: 8px;
  background: #fff;
  padding: 8px 10px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.tb-yes-no button.active {
  background: #2d57cf;
  color: #fff;
  border-color: #2d57cf;
}

.tb-alert-danger {
  margin-top: 12px;
  background: #e32025;
  color: #fff;
  border-radius: 10px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.tb-alert-info {
  margin-top: 12px;
  background: #1d4ed8;
  color: #fff;
  border-radius: 10px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.tb-exams-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.tb-exam-card {
  background: #f5f8ff;
  border: 1px solid #dce4f8;
  border-radius: 12px;
  padding: 10px;
}


.tb-checkbox-line {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #2f3a55;
  margin-bottom: 6px;
  
}

.tb-exam-fields {
  display: grid;
  gap: 8px;
  margin-top: 8px;
}

.tb-result-toggle {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.tb-result-toggle button {
  border: 1px solid #d5def2;
  border-radius: 8px;
  background: #fff;
  padding: 8px 10px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.tb-result-toggle button.active {
  background: #2d57cf;
  border-color: #2d57cf;
  color: #fff;
}

.tb-result-toggle button.active.positive {
  background: #d62828;
  border-color: #d62828;
}

.tb-text-block {
  margin-top: 12px;
  display: grid;
  gap: 8px;
}

.tb-sinan-box {
  margin-top: 12px;
  border: 1px solid #f2c38d;
  background: #fff8ee;
  border-radius: 12px;
  padding: 12px;
  display: grid;
  gap: 10px;
}

.tb-sinan-box p {
  margin: 4px 0 0;
  color: #6a4b2b;
  font-size: 13px;
}

.tb-file-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #2563eb;
  text-decoration: underline;
  margin-bottom: 4px;
}

.tb-btn-outline {
  border: 1px solid #f18b2b;
  color: #f18b2b;
  background: #fff;
  border-radius: 8px;
  padding: 8px 12px;
  width: fit-content;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
}

.tb-two-cols {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 10px;
}

.tb-three-cols {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 10px;
}

.tb-status-row {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  margin-top: 8px;
}

.tb-status-row button {
  border: 1px solid #d5def2;
  border-radius: 8px;
  background: #fff;
  padding: 8px 10px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.tb-status-row button.active {
  background: #2d57cf;
  border-color: #2d57cf;
  color: #fff;
}

.tb-sub-card {
  border: 1px solid #dce4f8;
  border-radius: 12px;
  padding: 12px;
  background: #f7f9ff;
}

.tb-btn-small {
  margin-top: 10px;
  border: none;
  border-radius: 8px;
  background: #2d57cf;
  color: #fff;
  padding: 10px 14px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.tb-timeline {
  margin-top: 14px;
  border-left: 2px solid #c7d5f7;
  padding-left: 12px;
  display: grid;
  gap: 10px;
}

.tb-timeline-item {
  border: 1px solid #e3e9f7;
  border-radius: 12px;
  background: #fff;
  padding: 10px 12px;
}

.tb-timeline-item strong {
  color: #2d57cf;
}

.tb-timeline-item p {
  margin: 6px 0 0;
  font-size: 13px;
}

.tb-transfer-box {
  margin-top: 12px;
  border: 1px solid #bfd2fb;
  border-radius: 12px;
  background: #f2f7ff;
  padding: 12px;
}

.tb-transfer-box h5 {
  margin: 0 0 12px;
  color: #294db4;
}

.tb-samples-header {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #dce4f8;
  padding: 10px;
}

.tb-samples-list {
  display: grid;
  gap: 8px;
  margin: 10px 0;
}

.tb-sample-row {
  border: 1px solid #dce4f8;
  border-radius: 10px;
  background: #fff;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}

.tb-sample-row>span {
  font-weight: 700;
  color: #6b7692;
}

.tb-sample-remove {
  margin-left: auto;
  border: 1px solid #e35d6a;
  background: #fff;
  color: #c61f2e;
  border-radius: 8px;
  font-weight: 700;
  width: 34px;
  height: 34px;
  cursor: pointer;
}

.tb-footer-action {
  margin-top: 14px;
}

.tb-finish-btn {
  background: #2ea44f !important;
}

/* Odontograma - Odontologia */
.odontogram-card {
  border: 1px solid #dce4f8;
  background: linear-gradient(180deg, #f9fbff 0%, #f2f6ff 100%);
  border-radius: 14px;
  padding: 14px;
  display: grid;
  gap: 12px;
}

.odontogram-help {
  margin: 0;
  font-size: 13px;
  color: #516083;
}

.odontogram-row {
  display: grid;
  grid-template-columns: repeat(16, minmax(0, 1fr));
  gap: 6px;
  align-items: center;
}

.odontogram-row.upper {
  margin-bottom: 2px;
}

.odontogram-row.lower {
  margin-top: 2px;
}

.odontogram-tooth {
  border: 1px solid #c8d4ef;
  background: linear-gradient(180deg, #ffffff 0%, #edf2ff 100%);
  color: #2e3f69;
  border-radius: 999px;
  height: 38px;
  padding: 4px 0;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(62, 87, 150, 0.16);
  transform: translateY(var(--tooth-shift, 0px));
  transition: transform 0.2s ease, border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
}

.odontogram-tooth:hover {
  border-color: #7d9be6;
  background: linear-gradient(180deg, #f4f8ff 0%, #e6eeff 100%);
  box-shadow: 0 4px 10px rgba(62, 87, 150, 0.22);
  transform: translateY(var(--tooth-shift, 0px)) scale(1.04);
}

.odontogram-tooth.marked {
  background: linear-gradient(180deg, #e6f1ff 0%, #d6e8ff 100%);
  border-color: #4f7fd8;
  color: #173c83;
  box-shadow: 0 0 0 2px rgba(79, 127, 216, 0.25), 0 3px 8px rgba(44, 78, 163, 0.2);
}

.odontogram-tooth.active {
  background: #2d57cf;
  border-color: #2d57cf;
  color: #fff;
  box-shadow: 0 5px 12px rgba(45, 87, 207, 0.32);
  transform: translateY(var(--tooth-shift, 0px)) scale(1.03);
}

.odontogram-legend {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  align-items: center;
  font-size: 12px;
  color: #47577f;
  margin-top: 8px;
}

.odontogram-legend span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}

.legend-dot.selected {
  background: #2d57cf;
}

.legend-dot.marked {
  background: #d6e8ff;
  border: 1px solid #4f7fd8;
}

@media (max-width: 960px) {

  .tb-exams-grid,
  .tb-two-cols,
  .tb-three-cols,
  .tb-status-row {
    grid-template-columns: 1fr;
  }

  .odontogram-row {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .tb-triage-item {
    flex-direction: column;
    align-items: flex-start;
  }
}

.med-remedy-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.med-remedy-wrapper select {
  flex: 1 1;
}

.med-add-remedy-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 30px;
  border-radius: 10px;
  border: 1.5px solid var(--texto-destaque);
  background: var(--fundo);
  color: var(--texto-destaque);
  cursor: pointer;
  font-size: 1rem;
  flex-shrink: 0;
}

.med-edit-btn {
  background: none;
  border: none;
  box-shadow: none;
  padding: 0 0 0 8px;
  cursor: pointer;
  color: inherit;
}

/* Botão lápis na timeline de evolução */
.timeline-edit-btn {
  border: none;
  box-shadow: none;
  padding: 0 0 0 8px;
  cursor: pointer;
  line-height: 1;
  vertical-align: middle;
  transition: color 0.15s ease;
}

.timeline-edit-btn:hover {
  color: var(--azul);
}

/* Nome da unidade abaixo da data na timeline de acolhimento */
.timeline-unit {
  font-size: 12px;
  color: #888;
  margin-top: -4px;
  margin-bottom: 6px;
}

/* Modal de edição de evolução */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-box {
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-lg);
  box-shadow: var(--ui-shadow-md);
  padding: 32px;
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.modal-title {
  margin: 0 0 4px;
  font-size: 15px;
  font-weight: 700;
  color: var(--ui-text);
}

.modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 4px;
}

.modal-cancel-btn {
  background: transparent;
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-sm);
  padding: 8px 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  color: var(--ui-text);
  transition: background 0.15s ease;
}

.modal-cancel-btn:hover {
  background: var(--ui-hover);
}

.required-indicator {
  color: #d32f2f;
  font-weight: 700;
  margin-left: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Saude/saude.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;;;AAGA,kCAAkC;AAClC;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,2BAA2B;AAC3B;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,aAAa;EACb,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,WAAW;EACX,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,6DAA6D;EAC7D,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAc;AAChB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,2BAA2B;IAC3B,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,0BAA0B;EAC5B;AACF;;AAEA,iCAAiC;AACjC;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;;;;;;;EASE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;;;;;;;;EASE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,kBAAkB;;AAEpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iDAAiD;EACjD,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,6DAA6D;EAC7D,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6CAA6C;EAC7C,8CAA8C;EAC9C,mGAAmG;AACrG;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;EAC7D,8CAA8C;EAC9C,0DAA0D;AAC5D;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;EACd,gFAAgF;AAClF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,8CAA8C;EAC9C,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE;;;;IAIE,0BAA0B;EAC5B;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,wBAAwB;EACxB,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,8DAA8D;AAC9D;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;EAC/B,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,kCAAkC;EAClC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":["/* Textarea psicologia */\n.textarea-full {\n  flex: 1 1 100%;\n  /* Ocupar toda a largura disponível */\n}\n\n.textarea-full textarea {\n  width: 100%;\n  resize: none;\n  /* Impedir o redimensionamento */\n}\n\n\n/* Flags da admisaão ou consulta */\n.flag-admissao {\n  color: #0a7c0a;\n  font-weight: bold;\n}\n\n.flag-consulta {\n  color: #004aad;\n  font-weight: bold;\n}\n\n.flag-consulta-button {\n  background: none;\n  border: none;\n  color: #007bff;\n  font-weight: bold;\n}\n\n/* Layout genérico para páginas estáticas de saúde */\n.health-shell {\n  display: flex;\n  min-height: 100vh;\n  background: #f6f8ff;\n}\n\n.health-shell-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: #f6f8ff;\n}\n\n.health-shell-body {\n  padding: 16px 20px 28px;\n  background: #f6f8ff;\n}\n\n.health-search-card {\n  background: #fff;\n  border: 1px solid #e7ebf5;\n  border-radius: 14px;\n  padding: 12px 14px;\n  box-shadow: 0 6px 18px rgba(17, 24, 39, 0.06);\n  margin-bottom: 16px;\n}\n\n.health-static-section {\n  background: #f6f8ff;\n  border-radius: 16px;\n  padding: 12px;\n}\n\n.health-static-layout {\n  display: grid;\n  grid-template-columns: 220px 1fr;\n  gap: 18px;\n  align-items: start;\n  margin-top: 8px;\n}\n\n.health-static-avatar {\n  background: #fff;\n  border: 1px solid #e7ebf5;\n  border-radius: 16px;\n  padding: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 240px;\n  box-shadow: 0 8px 20px rgba(17, 24, 39, 0.05);\n}\n\n.health-static-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 12px;\n}\n\n.health-static-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 12px;\n}\n\n.health-static-field {\n  background: #fff;\n  border: 1px solid #e7ebf5;\n  border-radius: 12px;\n  padding: 12px 14px;\n  min-height: 64px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  box-shadow: 0 4px 14px rgba(17, 24, 39, 0.04);\n}\n\n.health-static-field span {\n  font-size: 13px;\n  font-weight: 700;\n  color: #3a4a70;\n  margin-bottom: 6px;\n}\n\n.health-static-field p {\n  font-size: 14px;\n  color: #4b5563;\n  margin: 0;\n}\n\n@media (max-width: 900px) {\n  .health-static-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .health-static-avatar {\n    height: 200px;\n  }\n}\n\n/* Formulário de Admissão */\n.health-card {\n  background: var(--ui-surface);\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-lg);\n  padding: 16px;\n  margin-top: 16px;\n  box-shadow: var(--ui-shadow-sm);\n}\n\n.health-grid-two {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 12px;\n  margin-top: 10px;\n}\n\n.health-options-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 16px;\n  align-items: center;\n  margin-top: 8px;\n}\n\n.toggle-field {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  background: #f3f6ff;\n  border: 1px solid #e1e7f5;\n  padding: 8px 12px;\n  border-radius: 999px;\n}\n\n.toggle-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #6b7a90;\n  min-width: 32px;\n  text-align: center;\n}\n\n.toggle-label.active {\n  color: #1c3faa;\n}\n\n.toggle-switch {\n  position: relative;\n  width: 44px;\n  height: 24px;\n  display: inline-block;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #cfd8ee;\n  transition: 0.2s ease;\n  border-radius: 999px;\n}\n\n.toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  top: 3px;\n  background-color: #fff;\n  transition: 0.2s ease;\n  border-radius: 50%;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.toggle-switch input:checked+.toggle-slider {\n  background-color: #1c6ef2;\n}\n\n.toggle-switch input:checked+.toggle-slider:before {\n  transform: translateX(20px);\n}\n\n.health-option {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 14px;\n  color: var(--ui-text);\n}\n\n.health-option-set {\n  background: var(--ui-input-bg);\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-md);\n  padding: 10px;\n}\n\n.health-subtitle {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--ui-text);\n  margin: 0 0 6px 0;\n}\n\n.health-inline-input {\n  width: 100%;\n  min-width: 180px;\n  padding: 10px 12px;\n  border: 1px solid #d7dce8;\n  border-radius: 10px;\n  outline: none;\n  font-size: 14px;\n  background-color: #fff !important;\n}\n\n.health-inline-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 12px;\n  margin-top: 12px;\n}\n\n.health-table {\n  margin-top: 12px;\n  border: 1px solid #e7ebf5;\n  border-radius: 12px;\n  overflow: hidden;\n  width: 100%;\n  background: #fff;\n  box-shadow: 0 6px 16px rgba(17, 24, 39, 0.04);\n}\n\n.health-table-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  border-bottom: 1px solid #eef1f7;\n  background: #fff;\n  align-items: center;\n}\n\n.health-table-row:last-child {\n  border-bottom: none;\n}\n\n.health-table-row div {\n  padding: 10px 12px;\n  font-size: 14px;\n  color: #2e3b5f;\n}\n\n.health-table-row.header {\n  background: #f6f8ff;\n  font-weight: 600;\n  color: #1f2a44;\n  position: static;\n  text-transform: uppercase;\n  letter-spacing: 0.2px;\n  font-size: 12px;\n  padding: 10px;\n}\n\n.health-table-row.active {\n  background: #eef2ff;\n}\n\n.health-table.three-cols .health-table-row {\n  grid-template-columns: 1fr 1fr 1fr;\n}\n\n.health-table.five-cols .health-table-row {\n  grid-template-columns: 1.1fr 0.7fr 0.7fr 0.7fr 1.3fr;\n}\n\n.health-table-row input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  display: block;\n  margin: 0 auto;\n}\n\n.health-table-row input[type=\"text\"] {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #dce1ee;\n  border-radius: 10px;\n  background: #f7f8ff;\n}\n\n.health-table-row.header {\n  position: static;\n}\n\n.health-inline-input.highlight {\n  background: #eef2ff;\n  border-color: #d4dbf7;\n}\n\n.demand-form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.demand-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 12px;\n  align-items: flex-start;\n}\n\n.demand-col {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.demand-col textarea,\n.demand-col input[type=\"text\"],\n.demand-col input[type=\"date\"],\n.demand-col input[type=\"time\"] {\n  width: 100%;\n}\n\n.demand-col.flex-1 {\n  flex: 1 1 100%;\n}\n\n.demand-col.flex-2 {\n  flex: 1 1 48%;\n}\n\n.demand-col.flex-3 {\n  flex: 1 1 60%;\n}\n\n.demand-row.vitals {\n  gap: 8px 10px;\n  margin-top: 0;\n}\n\n.tb-section-block {\n  width: 100%;\n  border: 1px solid #e7ebf5;\n  border-radius: 12px;\n  padding: 12px;\n  background: #fff;\n  margin-top: 10px;\n}\n\n.tb-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 14px;\n  align-items: flex-start;\n}\n\n.tb-col {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex: 1 1 220px;\n}\n\n.tb-col.flex-1 {\n  flex: 1 1 100%;\n}\n\n.tb-col input,\n.tb-col select,\n.tb-col textarea {\n  width: 100%;\n}\n\n.ficha-pdf {\n  margin-top: 20px;\n}\n\n.question-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 12px;\n  width: 100%;\n  justify-content: stretch;\n  align-items: stretch;\n}\n\n.question-card {\n  background: #f7f9fe;\n  border: 1px solid #e7ebf5;\n  border-radius: 12px;\n  padding: 12px 14px;\n  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);\n}\n\n.question-title {\n  margin: 0 0 8px 0;\n  font-weight: 600;\n  color: #2c3a4b;\n  font-size: 14px;\n}\n\n@media (max-width: 768px) {\n  .demand-row {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 640px) {\n  .health-inline-input {\n    min-width: 0;\n  }\n\n  .health-options-row {\n    gap: 8px;\n  }\n}\n\n.health-inline-action {\n  border: none;\n  background: transparent;\n  color: #2a5dc7;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n  margin-top: 6px;\n}\n\n.health-inline-action:hover {\n  text-decoration: underline;\n}\n\n.timeline-inline {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.health-inline-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: 8px;\n}\n\n.health-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.health-list__row {\n  align-items: end;\n}\n\n.health-inline-add {\n  border: 1px dashed #9bb4e6;\n  background: #f3f6ff;\n  color: #2a5dc7;\n  font-weight: 600;\n  border-radius: 10px;\n  padding: 8px 12px;\n  cursor: pointer;\n}\n\n.health-inline-add:hover {\n  background: #eef2ff;\n}\n\n.health-inline-remove {\n  width: 32px;\n  height: 32px;\n  border-radius: 10px;\n  border: 1px solid #f2b8b5;\n  background: #fff;\n  color: #cc3b3b;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.health-note {\n  margin: 6px 0 14px;\n  font-size: 0.9rem;\n  color: #6c7a94;\n}\n\n.health-input-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.health-input-actions .health-inline-input {\n  flex: 1;\n}\n\n.health-action-btn {\n  border: 1px solid #cfd8ee;\n  background: #f7f9ff;\n  color: #41527a;\n  border-radius: 6px;\n  width: 24px;\n  height: 24px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n}\n\n.health-action-btn.danger {\n  border-color: #efc5c5;\n  color: #c43c3c;\n  background: #fff6f6;\n  padding: 0;\n}\n\n.health-action-btn:hover {\n  background: #edf2ff;\n}\n\n.health-action-btn.danger:hover {\n  background: #ffeaea;\n}\n\n.health-row-below {\n  display: flex;\n  justify-content: flex-end;\n  padding: 10px 20px 10px 0px;\n}\n\n.health-row-file {\n  display: flex;\n  justify-content: flex-start;\n  padding: 6px 0 4px;\n}\n\n.health-row-file input[type=\"file\"] {\n  width: 100%;\n  max-width: 320px;\n}\n\n/* === Admissão (novo layout) === */\n.admission-page {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.admission-header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 4px 4px 0;\n}\n\n.admission-title h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1e2a45;\n}\n\n.admission-title p {\n  margin: 6px 0 0;\n  color: #6b7a99;\n  font-size: 0.95rem;\n}\n\n.admission-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.admission-chip {\n  background: #eef2ff;\n  color: #2c3e6b;\n  padding: 6px 12px;\n  border-radius: 999px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  border: 1px solid #dfe6fb;\n}\n\n.admission-hero {\n  display: grid;\n  grid-template-columns: 150px 1fr;\n  gap: 20px;\n  padding: 18px;\n  border-radius: 18px;\n  background: linear-gradient(135deg, #f8faff 0%, #ffffff 100%);\n  border: 1px solid #e4e9f6;\n  box-shadow: 0 8px 24px rgba(17, 24, 39, 0.06);\n}\n\n.admission-hero-avatar img {\n  width: 150px;\n  height: 150px;\n  border-radius: 16px;\n  object-fit: cover;\n  border: 1px solid #e0e6f5;\n}\n\n.admission-hero-content {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.admission-hero-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 12px 18px;\n}\n\n.admission-hero-row--3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.admission-hero-row--2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.admission-info-item {\n  background: #f7f9ff;\n  border: 1px solid #e2e8fb;\n  border-radius: 12px;\n  padding: 10px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.admission-info-item span {\n  font-size: 0.78rem;\n  color: #7a88a8;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.admission-info-item strong {\n  font-size: 0.95rem;\n  color: #1f2a44;\n  font-weight: 600;\n}\n\n.admission-card {\n  background: #ffffff;\n  border: 1px solid #e4e9f6;\n  border-radius: 18px;\n  padding: 18px;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);\n}\n\n.admission-card__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.admission-card__header h3 {\n  margin: 0;\n  font-size: 1.1rem;\n  color: #1e2a45;\n}\n\n.admission-card__hint {\n  font-size: 0.82rem;\n  color: #7b88a6;\n}\n\n.admission-grid {\n  display: grid;\n  gap: 14px;\n}\n\n.admission-grid,\n.admission-grid {\n  margin-top: 14px;\n}\n\n.admission-grid--2 {\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n}\n\n.admission-grid--3 {\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n}\n\n.admission-input {\n  background: #f6f8ff;\n}\n\n.admission-actions {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 4px;\n  gap: 6px;\n}\n\n.admission-timeline {\n  margin-top: 6px;\n  background: #ffffff;\n  border: 1px solid #e4e9f6;\n  border-radius: 18px;\n  padding: 18px;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);\n}\n\n.timeline-vitals {\n  padding: 10px;\n  background-color: #f7f9ff;\n}\n\n.timeline-vitals-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 6px 12px;\n  font-size: 0.92rem;\n}\n\n@media (max-width: 1480px) {\n  .admission-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .admission-title {\n    width: 100%;\n  }\n\n  .admission-chips {\n    width: 100%;\n    justify-content: flex-start;\n    gap: 8px;\n  }\n\n  .admission-chip {\n    font-size: 0.8rem;\n    padding: 5px 10px;\n  }\n}\n\n@media (max-width: 960px) {\n  .admission-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .admission-hero {\n    grid-template-columns: 1fr;\n  }\n\n  .admission-hero-avatar img {\n    width: 96px;\n    height: 96px;\n  }\n\n  .admission-hero-row--3,\n  .admission-hero-row--2 {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Fluxo de tuberculose em abas */\n.tb-tabs-layout {\n  padding: 18px;\n}\n\n.tb-tabs-header {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 14px;\n}\n\n.tb-tab-btn {\n  border: 1px solid #d5def2;\n  background: #f7f9ff;\n  color: #2d3e66;\n  padding: 8px 12px;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.tb-tab-btn.active {\n  background: #2d57cf;\n  border-color: #2d57cf;\n  color: #fff;\n}\n\n.tb-tab-btn.disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.tb-step-card {\n  border: 1px solid #e4e9f6;\n  border-radius: 14px;\n  padding: 14px;\n  background: #fbfcff;\n}\n\n.tb-step-card h4 {\n  margin: 0 0 12px;\n  color: #1f2a44;\n  font-size: 1.05rem;\n}\n\n.tb-step-card input:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"file\"]),\n.tb-step-card select,\n.tb-step-card textarea,\n.tb-transfer-box input:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"file\"]),\n.tb-transfer-box select,\n.tb-transfer-box textarea,\n.tb-sinan-box input:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"file\"]),\n.tb-sinan-box select,\n.tb-sinan-box textarea {\n  background: #fff;\n  border: 1px solid #d7dce8;\n  border-radius: 10px;\n}\n\n.tb-step-card input:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"file\"]):focus,\n.tb-step-card select:focus,\n.tb-step-card textarea:focus,\n.tb-transfer-box input:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"file\"]):focus,\n.tb-transfer-box select:focus,\n.tb-transfer-box textarea:focus,\n.tb-sinan-box input:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"file\"]):focus,\n.tb-sinan-box select:focus,\n.tb-sinan-box textarea:focus {\n  outline: none;\n  border-color: #8fb0f5;\n  box-shadow: 0 0 0 3px rgba(45, 87, 207, 0.08);\n}\n\n.tb-triage-list {\n  display: grid;\n  gap: 10px;\n}\n\n.tb-triage-item {\n  border: 1px solid #e2e8fb;\n  border-radius: 12px;\n  background: #f7f9ff;\n  padding: 10px 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n\n.tb-triage-item p {\n  margin: 0;\n  font-size: 14px;\n  color: #2a3550;\n}\n\n.tb-yes-no {\n  display: flex;\n  gap: 8px;\n}\n\n.tb-yes-no button {\n  min-width: 56px;\n  border: 1px solid #d2dbef;\n  border-radius: 8px;\n  background: #fff;\n  padding: 8px 10px;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.tb-yes-no button.active {\n  background: #2d57cf;\n  color: #fff;\n  border-color: #2d57cf;\n}\n\n.tb-alert-danger {\n  margin-top: 12px;\n  background: #e32025;\n  color: #fff;\n  border-radius: 10px;\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.tb-alert-info {\n  margin-top: 12px;\n  background: #1d4ed8;\n  color: #fff;\n  border-radius: 10px;\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.tb-exams-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.tb-exam-card {\n  background: #f5f8ff;\n  border: 1px solid #dce4f8;\n  border-radius: 12px;\n  padding: 10px;\n}\n\n\n.tb-checkbox-line {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #2f3a55;\n  margin-bottom: 6px;\n  \n}\n\n.tb-exam-fields {\n  display: grid;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.tb-result-toggle {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.tb-result-toggle button {\n  border: 1px solid #d5def2;\n  border-radius: 8px;\n  background: #fff;\n  padding: 8px 10px;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.tb-result-toggle button.active {\n  background: #2d57cf;\n  border-color: #2d57cf;\n  color: #fff;\n}\n\n.tb-result-toggle button.active.positive {\n  background: #d62828;\n  border-color: #d62828;\n}\n\n.tb-text-block {\n  margin-top: 12px;\n  display: grid;\n  gap: 8px;\n}\n\n.tb-sinan-box {\n  margin-top: 12px;\n  border: 1px solid #f2c38d;\n  background: #fff8ee;\n  border-radius: 12px;\n  padding: 12px;\n  display: grid;\n  gap: 10px;\n}\n\n.tb-sinan-box p {\n  margin: 4px 0 0;\n  color: #6a4b2b;\n  font-size: 13px;\n}\n\n.tb-file-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  color: #2563eb;\n  text-decoration: underline;\n  margin-bottom: 4px;\n}\n\n.tb-btn-outline {\n  border: 1px solid #f18b2b;\n  color: #f18b2b;\n  background: #fff;\n  border-radius: 8px;\n  padding: 8px 12px;\n  width: fit-content;\n  font-size: 12px;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.tb-two-cols {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.tb-three-cols {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.tb-status-row {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.tb-status-row button {\n  border: 1px solid #d5def2;\n  border-radius: 8px;\n  background: #fff;\n  padding: 8px 10px;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.tb-status-row button.active {\n  background: #2d57cf;\n  border-color: #2d57cf;\n  color: #fff;\n}\n\n.tb-sub-card {\n  border: 1px solid #dce4f8;\n  border-radius: 12px;\n  padding: 12px;\n  background: #f7f9ff;\n}\n\n.tb-btn-small {\n  margin-top: 10px;\n  border: none;\n  border-radius: 8px;\n  background: #2d57cf;\n  color: #fff;\n  padding: 10px 14px;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.tb-timeline {\n  margin-top: 14px;\n  border-left: 2px solid #c7d5f7;\n  padding-left: 12px;\n  display: grid;\n  gap: 10px;\n}\n\n.tb-timeline-item {\n  border: 1px solid #e3e9f7;\n  border-radius: 12px;\n  background: #fff;\n  padding: 10px 12px;\n}\n\n.tb-timeline-item strong {\n  color: #2d57cf;\n}\n\n.tb-timeline-item p {\n  margin: 6px 0 0;\n  font-size: 13px;\n}\n\n.tb-transfer-box {\n  margin-top: 12px;\n  border: 1px solid #bfd2fb;\n  border-radius: 12px;\n  background: #f2f7ff;\n  padding: 12px;\n}\n\n.tb-transfer-box h5 {\n  margin: 0 0 12px;\n  color: #294db4;\n}\n\n.tb-samples-header {\n  margin-top: 10px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  border-bottom: 1px solid #dce4f8;\n  padding: 10px;\n}\n\n.tb-samples-list {\n  display: grid;\n  gap: 8px;\n  margin: 10px 0;\n}\n\n.tb-sample-row {\n  border: 1px solid #dce4f8;\n  border-radius: 10px;\n  background: #fff;\n  padding: 10px 12px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex-wrap: wrap;\n}\n\n.tb-sample-row>span {\n  font-weight: 700;\n  color: #6b7692;\n}\n\n.tb-sample-remove {\n  margin-left: auto;\n  border: 1px solid #e35d6a;\n  background: #fff;\n  color: #c61f2e;\n  border-radius: 8px;\n  font-weight: 700;\n  width: 34px;\n  height: 34px;\n  cursor: pointer;\n}\n\n.tb-footer-action {\n  margin-top: 14px;\n}\n\n.tb-finish-btn {\n  background: #2ea44f !important;\n}\n\n/* Odontograma - Odontologia */\n.odontogram-card {\n  border: 1px solid #dce4f8;\n  background: linear-gradient(180deg, #f9fbff 0%, #f2f6ff 100%);\n  border-radius: 14px;\n  padding: 14px;\n  display: grid;\n  gap: 12px;\n}\n\n.odontogram-help {\n  margin: 0;\n  font-size: 13px;\n  color: #516083;\n}\n\n.odontogram-row {\n  display: grid;\n  grid-template-columns: repeat(16, minmax(0, 1fr));\n  gap: 6px;\n  align-items: center;\n}\n\n.odontogram-row.upper {\n  margin-bottom: 2px;\n}\n\n.odontogram-row.lower {\n  margin-top: 2px;\n}\n\n.odontogram-tooth {\n  border: 1px solid #c8d4ef;\n  background: linear-gradient(180deg, #ffffff 0%, #edf2ff 100%);\n  color: #2e3f69;\n  border-radius: 999px;\n  height: 38px;\n  padding: 4px 0;\n  font-size: 11px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 2px 6px rgba(62, 87, 150, 0.16);\n  transform: translateY(var(--tooth-shift, 0px));\n  transition: transform 0.2s ease, border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;\n}\n\n.odontogram-tooth:hover {\n  border-color: #7d9be6;\n  background: linear-gradient(180deg, #f4f8ff 0%, #e6eeff 100%);\n  box-shadow: 0 4px 10px rgba(62, 87, 150, 0.22);\n  transform: translateY(var(--tooth-shift, 0px)) scale(1.04);\n}\n\n.odontogram-tooth.marked {\n  background: linear-gradient(180deg, #e6f1ff 0%, #d6e8ff 100%);\n  border-color: #4f7fd8;\n  color: #173c83;\n  box-shadow: 0 0 0 2px rgba(79, 127, 216, 0.25), 0 3px 8px rgba(44, 78, 163, 0.2);\n}\n\n.odontogram-tooth.active {\n  background: #2d57cf;\n  border-color: #2d57cf;\n  color: #fff;\n  box-shadow: 0 5px 12px rgba(45, 87, 207, 0.32);\n  transform: translateY(var(--tooth-shift, 0px)) scale(1.03);\n}\n\n.odontogram-legend {\n  display: flex;\n  gap: 14px;\n  flex-wrap: wrap;\n  align-items: center;\n  font-size: 12px;\n  color: #47577f;\n  margin-top: 8px;\n}\n\n.odontogram-legend span {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.legend-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.legend-dot.selected {\n  background: #2d57cf;\n}\n\n.legend-dot.marked {\n  background: #d6e8ff;\n  border: 1px solid #4f7fd8;\n}\n\n@media (max-width: 960px) {\n\n  .tb-exams-grid,\n  .tb-two-cols,\n  .tb-three-cols,\n  .tb-status-row {\n    grid-template-columns: 1fr;\n  }\n\n  .odontogram-row {\n    grid-template-columns: repeat(8, minmax(0, 1fr));\n  }\n\n  .tb-triage-item {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n.med-remedy-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.med-remedy-wrapper select {\n  flex: 1;\n}\n\n.med-add-remedy-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 30px;\n  border-radius: 10px;\n  border: 1.5px solid var(--texto-destaque);\n  background: var(--fundo);\n  color: var(--texto-destaque);\n  cursor: pointer;\n  font-size: 1rem;\n  flex-shrink: 0;\n}\n\n.med-edit-btn {\n  background: none;\n  border: none;\n  box-shadow: none;\n  padding: 0 0 0 8px;\n  cursor: pointer;\n  color: inherit;\n}\n\n/* Botão lápis na timeline de evolução */\n.timeline-edit-btn {\n  border: none;\n  box-shadow: none;\n  padding: 0 0 0 8px;\n  cursor: pointer;\n  line-height: 1;\n  vertical-align: middle;\n  transition: color 0.15s ease;\n}\n\n.timeline-edit-btn:hover {\n  color: var(--azul);\n}\n\n/* Nome da unidade abaixo da data na timeline de acolhimento */\n.timeline-unit {\n  font-size: 12px;\n  color: #888;\n  margin-top: -4px;\n  margin-bottom: 6px;\n}\n\n/* Modal de edição de evolução */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(17, 24, 39, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-box {\n  background: var(--ui-surface);\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-lg);\n  box-shadow: var(--ui-shadow-md);\n  padding: 32px;\n  width: 100%;\n  max-width: 480px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.modal-title {\n  margin: 0 0 4px;\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--ui-text);\n}\n\n.modal-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  margin-top: 4px;\n}\n\n.modal-cancel-btn {\n  background: transparent;\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-sm);\n  padding: 8px 18px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  color: var(--ui-text);\n  transition: background 0.15s ease;\n}\n\n.modal-cancel-btn:hover {\n  background: var(--ui-hover);\n}\n\n.required-indicator {\n  color: #d32f2f;\n  font-weight: 700;\n  margin-left: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
